export default "__VITE_ASSET__f31bae37__"